// Author thq
// Date 2022-02-17 15:57:52

import * as model from "@/model/em/repair/RepairSppOrderModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairSppOrder(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
        callbackApi: process.env.VUE_APP_EM_REPAIR_URL + '/repairSppOrder/workflow/complete-feedback',
        processDefinitionKey: "em_repair_spp_order",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
